class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
        window.isExciseSyncing = true;
        disableCheckoutButton();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    
    const debouncedOnChange = debounce((event) => {
      console.log("On Change triggered");
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      // ✅ Don't re-render the whole cart on excise-tax add
      // It was already rendered by product-form.js renderContents()
      if (event.source === 'excise-tax') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    window.isExciseSyncing = true;
    disableCheckoutButton();
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        syncExciseQuantities(parsedState.items);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        // Do NOT disable checkout here — this runs at the END of the update
        // and left the button stuck. healExcise() re-enables it once tax is confirmed.
      });

  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* ==========================================================================
   EXCISE TAX RECONCILER
   Excise tax is a pure function of (cart contents, province).
   Never add or subtract — read the cart, compute the correct absolute
   quantity for every tax variant, write that. Prior errors self-correct.
   ========================================================================== */

const ExciseTax = (() => {
  const EXCISE_TYPE = 'excise tax';

  // Every variant that IS a tax line. From Liquid config, so it stays complete
  // even if localStorage was cleared — this is what makes orphans findable.
  function taxVariantIds() {
    const ids = new Set();
    const data = window.collectionExciseData || {};
    for (const handle in data) {
      const m = data[handle];
      if (!m) continue;
      if (m.federal) ids.add(String(m.federal));
      if (m.provincial) ids.add(String(m.provincial));
    }
    return ids;
  }

  // What SHOULD the cart hold? No writes, no network, no history.
  // Returns null if province is unknown — never guess at tax.
  function desired(cart) {
    const province = localStorage.getItem('userProvince');
    if (!province) return null;

    const rules = (window.shopSettings && window.shopSettings.exciseProvinceRules) || {};
    const basis = window.exciseVariantBasis || {};
    const data = window.collectionExciseData || {};
    const want = new Map();

    for (const item of cart.items) {
      if (item.product_type === EXCISE_TYPE) continue; // never tax a tax line

      const handle = basis[String(item.variant_id)];
      if (!handle) continue; // not excisable (batteries, merch)

      const m = data[handle];
      if (!m || !m.federal) {
        console.error('[excise] collection has no federal tax variant:', handle);
        continue;
      }

      const fed = String(m.federal);
      want.set(fed, (want.get(fed) || 0) + item.quantity);

      if (rules[province] && m.provincial) {
        const prov = String(m.provincial);
        want.set(prov, (want.get(prov) || 0) + item.quantity);
      }
    }
    return want;
  }

  async function run() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('cart.js ' + res.status);
    const cart = await res.json();

    const want = desired(cart);
    if (want === null) {
      console.error('[excise] no province set — cannot compute tax');
      return { ok: false, reason: 'no-province' };
    }

    // Sum, don't overwrite: old code could split a variant across two lines.
    const have = new Map();
    for (const item of cart.items) {
      if (item.product_type !== EXCISE_TYPE) continue;
      const id = String(item.variant_id);
      have.set(id, (have.get(id) || 0) + item.quantity);
    }

    // Every tax variant gets an explicit verdict — present, owed, or configured
    // but absent. Iterating only what's present is how orphans survived.
    const domain = new Set([...taxVariantIds(), ...have.keys(), ...want.keys()]);

    const updates = {};
    for (const id of domain) {
      const target = want.get(id) || 0; // 0 removes the line
      if ((have.get(id) || 0) !== target) updates[id] = target;
    }

    if (Object.keys(updates).length === 0) return { ok: true, changed: false };

    // Tax lines are not merchandise - write through the pre-WPM fetch so the
    // reconciler stays invisible to all 12 pixels.
    const cartFetch = window.__unpixeledFetch || fetch;
    const write = await cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!write.ok) throw new Error('cart/update.js ' + write.status);

    return { ok: true, changed: true };
  }

  // Serialize — overlapping cart events must not interleave read-modify-write.
  let chain = Promise.resolve();
  let queued = null;

  function reconcile() {
    if (queued) return queued;
    queued = chain.then(() => {
      queued = null;
      return run();
    });
    chain = queued.catch(() => {}); // a failure must not poison the chain
    return queued;
  }

  return { reconcile, desired, run };
})();

window.ExciseTax = ExciseTax;

async function healExcise() {
  try {
    const r = await ExciseTax.reconcile();
    if (r && r.changed) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'excise-reconcile' });
    }
  } catch (e) {
    console.error('[excise] reconcile failed', e);
  } finally {
    enableCheckoutButton();
  }
}

/* Shims. product-form.js still calls these after its 1200ms timer, once per
   bundle parent and once per flavour. Under a reconciler that's harmless —
   each call just asks for the correct total and they coalesce into one write.
   So product-form.js needs no edits, and bundle double-charging disappears. */
window.handleExciseTaxAddition = function () {
  return healExcise();
};

function syncExciseQuantities() {
  return healExcise();
}

/* Coverage. Catches every path that mutates the cart, including the five with
   no excise handling: quick-add-bulk, quick-order-list, product-upsell-block,
   flavor-tabs, and the native form POST. None of those files are edited. */
// Empty cart at load (Liquid renders <cart-drawer class="is-empty">) has nothing
// to reconcile, so skip the /cart.js read. Adds still heal via the listeners below.
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && drawer.classList.contains('is-empty')) return;
  healExcise();
});
window.addEventListener('focus', healExcise);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) healExcise();
});
document.addEventListener('cart:updated', healExcise); // flavor-tabs.liquid

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event && event.source === 'excise-reconcile') return; // our own write
  healExcise();
});

// Province change flips provincial tax for the whole cart. Old code never recomputed.
window.addEventListener('storage', (e) => {
  if (e.key === 'userProvince') healExcise();
});
window.addEventListener('province:changed', healExcise);

function getCheckoutButton() {
  return document.getElementById('CartDrawer-Checkout');
}

function disableCheckoutButton() {
  const checkoutButton = getCheckoutButton();
  const spinner = document.getElementById('CheckoutSpinner');
  if (checkoutButton) {
    checkoutButton.disabled = true;
    checkoutButton.classList.add('checkout-btn-loading');
    if (!checkoutButton.dataset.originalText) {
      checkoutButton.dataset.originalText = checkoutButton.innerHTML;
    }
    checkoutButton.innerHTML = 'Updating...';
  }
  if (spinner) spinner.classList.remove('hidden');
}

// No setTimeout — the old 500ms delay was a guess. Callers now await real work.
function enableCheckoutButton() {
  const checkoutButton = getCheckoutButton();
  const spinner = document.getElementById('CheckoutSpinner');
  if (checkoutButton) {
    checkoutButton.disabled = false;
    checkoutButton.classList.remove('checkout-btn-loading');
    if (checkoutButton.dataset.originalText) {
      checkoutButton.innerHTML = checkoutButton.dataset.originalText;
    }
  }
  if (spinner) spinner.classList.add('hidden');
  window.isExciseSyncing = false;
}

/* Pre-checkout gate. Nothing reaches Shopify checkout until tax is confirmed
   against cart truth. A failed reconcile blocks checkout rather than shipping
   an order with the wrong tax. */
document.addEventListener(
  'submit',
  async (e) => {
    const form = e.target.closest && e.target.closest('form[action="/cart"]');
    if (!form) return;
    if (form.dataset.exciseVerified === 'true') return; // resubmit — let it through

    e.preventDefault();
    const submitter = e.submitter;
    disableCheckoutButton();

    try {
      const r = await ExciseTax.reconcile();
      if (!r || !r.ok) throw new Error((r && r.reason) || 'unknown');
      form.dataset.exciseVerified = 'true';

      /* The button that triggered this submit is now disabled (disableCheckoutButton
         above), and a disabled submitter is left out of the form data. The drawer's
         button carries name="checkout", the one field that tells Shopify to go to
         checkout instead of treating the POST as a cart update (which 302s back to
         /cart). Mirror it as a hidden field so it survives both the disabled state
         and the form.submit() fallback, which never includes a submitter at all. */
      if (
        submitter &&
        submitter.name &&
        !form.querySelector(`input[type="hidden"][name="${CSS.escape(submitter.name)}"]`)
      ) {
        const mirror = document.createElement('input');
        mirror.type = 'hidden';
        mirror.name = submitter.name;
        mirror.value = submitter.value || '';
        form.appendChild(mirror);
      }

      form.requestSubmit ? form.requestSubmit(submitter) : form.submit();
    } catch (err) {
      console.error('[excise] pre-checkout reconcile failed', err);
      enableCheckoutButton();
      alert('We could not confirm excise tax on your order. Please refresh and try again.');
    }
  },
  true
);
